import React from "react";
import styles from "./deleteButton.module.scss";
import { X } from "./Icons";
import classnames from "classnames/bind";
import { ConfirmableDeleteButton } from "./ConfirmableDeleteButton/ConfirmableDeleteButton";

const classNameBuilder = classnames.bind(styles);

export const DeleteButton = ({
  Icon = X,
  className,
  iconClassName,
  onClick,
  onOpen,
  onCancel,
  name,
  shouldConfirm,
  prefix,
  ...rest
}) => {
  return (
    <ConfirmableDeleteButton
      confirmationDisabled={!shouldConfirm}
      buttonProps={{
        round: true,
        className: classNameBuilder("container", className),
        ...rest,
      }}
      onConfirm={onClick}
      onCancel={onCancel}
      onOpen={onOpen}
      name={name}
    >
      {prefix}
      <Icon className={classNameBuilder("icon", iconClassName)} />
    </ConfirmableDeleteButton>
  );
};
